import { Space, Typography } from "antd";
import { FaCalendarAlt } from "react-icons/fa";
import dayjs from "dayjs";

type Props = {
  appointmentTime: string | null | undefined;
  size?: "small" | "default";
  format?: string;
  showIcon?: boolean;
};

const AppointmentTime = (props: Props) => {
  const {
    appointmentTime,
    size = "default",
    format = "DD/MM/YYYY HH:mm",
    showIcon = true,
  } = props;

  if (!appointmentTime) {
    return <Typography.Text type="secondary">-</Typography.Text>;
  }

  const formattedDate = dayjs(appointmentTime).format(format);
  const fontSize = size === "small" ? 12 : 14;
  const iconSize = size === "small" ? 12 : 14;

  return (
    <Space size={4}>
      {showIcon && (
        <FaCalendarAlt style={{ color: "#1890ff", fontSize: iconSize }} />
      )}
      <Typography.Text strong style={{ color: "#1890ff", fontSize }}>
        {formattedDate}
      </Typography.Text>
    </Space>
  );
};

export default AppointmentTime;
